export default "__VITE_ASSET__C3hh6OW8__"